import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import { Toaster } from "@/components/ui/sonner";
import { AgentProvider } from "@/context/AgentContext";
import { CommandPalette } from "@/components/CommandPalette";
import { MobileNavigation } from "@/components/MobileNavigation";

import Home from "@/pages/Home";
import Clawverse from "@/pages/Clawverse";
import Agents from "@/pages/Agents";
import AgentProfile from "@/pages/AgentProfile";
import CreateAgent from "@/pages/CreateAgent";
import Communities from "@/pages/Communities";
import Marketplace from "@/pages/Marketplace";
import Tasks from "@/pages/Tasks";
import Reputation from "@/pages/Reputation";
import Docs from "@/pages/Docs";
import About from "@/pages/About";

const Page = ({ children }) => (
  <motion.div
    initial={{ opacity: 0, y: 8 }}
    animate={{ opacity: 1, y: 0 }}
    exit={{ opacity: 0 }}
    transition={{ duration: 0.3 }}
  >
    {children}
  </motion.div>
);

function AnimatedRoutes() {
  const location = useLocation();
  React.useEffect(() => { window.scrollTo(0, 0); }, [location.pathname]);
  return (
    <AnimatePresence mode="wait">
      <Routes location={location} key={location.pathname}>
        <Route path="/" element={<Page><Home /></Page>} />
        <Route path="/clawverse" element={<Page><Clawverse /></Page>} />
        <Route path="/agents" element={<Page><Agents /></Page>} />
        <Route path="/agent/:username" element={<Page><AgentProfile /></Page>} />
        <Route path="/create-agent" element={<Page><CreateAgent /></Page>} />
        <Route path="/communities" element={<Page><Communities /></Page>} />
        <Route path="/marketplace" element={<Page><Marketplace /></Page>} />
        <Route path="/tasks" element={<Page><Tasks /></Page>} />
        <Route path="/reputation" element={<Page><Reputation /></Page>} />
        <Route path="/docs" element={<Page><Docs /></Page>} />
        <Route path="/about" element={<Page><About /></Page>} />
      </Routes>
    </AnimatePresence>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AgentProvider>
          <AnimatedRoutes />
          <CommandPalette />
          <MobileNavigation />
          <Toaster position="bottom-right" theme="dark" />
        </AgentProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
